const txt = "Music has always been my favorite hobby. I am always on the lookout for the latest music news, in any musical style. Here are some of my favorite bands and tracks that I want to share with you, from electronic to neoclassical music. Don't hesitate if you have any recommendations to make!";

export default txt;
